import Styles from './Loading.module.scss'
import cx from 'classnames'
import { Text } from 'blaze-ui/Text/Text'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'
import { Progress } from './Loading'
import { CSSProperties } from 'react'
import { Spinner } from 'common/Spinner/Spinner'
import { Check } from './Check'

interface LoadingProgressesProps {
  progresses: Progress[]
  gap?: number
  finishedLoading?: boolean
  showLoadingSpinner?: boolean
  loadingTextColor?: string
}

export const LoadingProgresses = ({
  progresses,
  gap = 16,
  finishedLoading,
  showLoadingSpinner = false,
  loadingTextColor = 'var(--dark-90)',
}: LoadingProgressesProps) => {
  const styles = {
    '--loading-text-color': loadingTextColor,
  } as CSSProperties

  return (
    <div className={Styles.headingsContainer} style={{ gap: `${gap}px`, ...styles }}>
      {progresses.map((progress, index) => {
        const isRunning = progress.isRunning || progress.percentComplete >= 99
        const isCompleted =
          finishedLoading ||
          (!progress.isRunning && progress.percentComplete === 100 && index !== progresses.length - 1)

        let title = progress.title
        if (isCompleted && progress.finishedTitle) {
          title = progress.finishedTitle
        } else if (isRunning && progress.processingTitle) {
          title = progress.processingTitle
        }

        return (
          <div
            className={cx(Styles.progressHeading, {
              [Styles.running]: isRunning,
              [Styles.completed]: isCompleted,
              [Styles.tintBlue]: showLoadingSpinner,
            })}
            key={index}
          >
            <div
              className={cx(Styles.progressItem, { [Styles.showLoadingSpinner]: showLoadingSpinner && index > 0 })}
              style={
                {
                  '--line-height': `${progress.lineHeight || 18}px`,
                } as CSSProperties
              }
            >
              {showLoadingSpinner && !isCompleted && isRunning ? (
                <Spinner className={Styles.spinner} />
              ) : (
                <div className={cx(Styles.progressItemCircle, { [Styles.completed]: isCompleted })}>
                  {isCompleted && <Check color="var(--light-100)" />}
                </div>
              )}
              <div className={Styles.textAndElementContainer}>
                <div className={Styles.textContainer}>
                  <Text color="var(--dark-90)">{title}</Text>
                  {
                    <div className={cx(Styles.ellipsesContainer, { [Styles.running]: progress.isRunning })}>
                      <LoadingEllipses />
                    </div>
                  }
                </div>
                {progress.element}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
